import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CatalogItemRow } from "../catalogItems.types";
import styles from "./DescriptionCell.module.scss";

export const DescriptionCell = memo(function DescriptionCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    return (
        <ViewTableCell className={styles.description}>
            {row.original.description ?? ""}
        </ViewTableCell>
    );
});
